export const steps = [
  {
    element: '.navbar-intro',
    intro:
      '<h5>Menu Lateral</h5><p>Aqui estão disponíveis de maneira organizada, todas as funcionalidades do portal.</p>',
    tooltipClass: 'tol-intro-navbar',
    highlightClass: 'elm-intro-navbar',
  },
  {
    element: 'header div',
    intro:
      "<h5>Dados cadastrais</h5><p>Aqui são exibidas suas Informações Cadastrais. No <span class='mdi mdi-bell'></span>, constam as notificações dos serviços que você utilizou no portal.</p>",
    tooltipClass: 'tol-intro-usermenu',
    highlightClass: 'elm-intro-usermenu',
  },
  {
    element: '.cards-intro',
    intro:
      '<h5>Acessos rápidos</h5><p>Aqui são os Acessos Rápidos, onde através de um clique você poderá ter acesso a funcionalidade que desejar. Clique no serviço desejado e tenha acesso à funcionalidade de forma fácil e rápida.</p>',
    tooltipClass: 'tol-intro-cards',
    highlightClass: 'elm-intro-cards',
  },
  {
    element: '.table1-intro',
    intro:
      "<h5>Últimos Abastecimentos</h5><p>Aqui são exibidas suas 2 (duas) últimas solicitações de abastecimentos. Caso queira ver todas, basta clicar em <b>'Abastecimento'</b> no Menu Lateral</p>",
    tooltipClass: 'tol-intro-table1',
    highlightClass: 'elm-intro-table1',
  },
  {
    element: '.table2-intro',
    intro:
      "<h5>Últimas Manutenções</h5><p>Aqui são exibidas suas 2 (duas) últimas solicitações de manutenção. Caso queira ver todas, basta clicar em <b>'Manutenção'</b> no Menu lateral</p>",
    tooltipClass: 'tol-intro-table2',
    highlightClass: 'elm-intro-table2',
  },
];

export const stepsMobile = [
  {
    element: '.bm-burger-button',
    intro:
      '<h5>Menu lateral</h5><p>Aqui estão disponíveis de maneira organizada, todas as funcionalidades do portal.</p>',
    tooltipClass: 'tol-intro-burger',
    highlightClass: 'elm-intro-burger',
  },
  {
    element: 'header div',
    intro:
      "<h5>Dados cadastrais</h5><p> suas Informações Cadastrais. No <span class='mdi mdi-bell'></span>, constam as notificações dos serviços que você utilizou no portal.</p>",
  },
  {
    element: '.cards-intro',
    intro:
      '<h5>Acessos rápidos</h5><p>Aqui são os Acessos Rápidos, onde através de um clique você poderá ter acesso a funcionalidade que desejar. Clique no serviço desejado e tenha acesso à funcionalidade de forma fácil e rápida.</p>',
  },
];
